<template>
    <div class="split_line">
        <img src="../../assets/img/splitLine.png">
    </div>
</template>

<script>

export default {
    name: 'SplitLine',
    components: {},
}

</script>
<style lang="scss" scoped>
.split_line {
    width: 100%;
    text-align: center;
}
</style>